import React from "react";

// Format number with thousand separator (Indonesian: dot)
export function formatRupiah(value) {
  if (value === "" || value === null || value === undefined) return "";
  const num = String(value).replace(/[^\d]/g, "");
  if (!num) return "";
  return num.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function parseRupiah(value) {
  if (value === "" || value === null || value === undefined) return 0;
  const num = String(value).replace(/[^\d]/g, "");
  return num ? parseInt(num, 10) : 0;
}

export default function RupiahInput({ value, onChange, testId, required, placeholder = "0" }) {
  const display = formatRupiah(value);

  const handleChange = (e) => {
    const raw = parseRupiah(e.target.value);
    onChange(raw);
  };

  return (
    <div style={{ display: "flex", alignItems: "stretch", border: "1px solid #828790", borderTopColor: "#404040", borderLeftColor: "#404040", background: "white" }}>
      <span style={{
        padding: "4px 8px",
        background: "#f0f0f0",
        borderRight: "1px solid #828790",
        fontSize: 13,
        fontWeight: 600,
        color: "#003399",
        userSelect: "none"
      }}>
        Rp
      </span>
      <input
        type="text"
        inputMode="numeric"
        value={display}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        data-testid={testId}
        className="vb-input"
        style={{ border: "none", textAlign: "right", flex: 1 }}
      />
    </div>
  );
}
